import { cn } from '@/lib/cn';

const PALETTE = ['#ff5a1f', '#0f766e', '#7c3aed', '#2563eb', '#db2777', '#ca8a04'];

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
}

function colorFor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function OrgAvatar({ name, size = 34, className }: { name: string; size?: number; className?: string }) {
  return (
    <span
      className={cn('inline-flex flex-shrink-0 items-center justify-center rounded-full font-bold text-white', className)}
      style={{ width: size, height: size, backgroundColor: colorFor(name), fontSize: Math.round(size * 0.35) }}
    >
      {initials(name)}
    </span>
  );
}
